import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "esports_fortnite_a69ef",
  "use": "esports_fortnite_a69ef-usage",
  "viewBox": "0 0 234 234",
  "content": "<symbol viewBox=\"0 0 234 234\" id=\"esports_fortnite_a69ef\">\n    <g fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M0 21.443h63.156V0h110.135l-3 21.443h63.346l-6.403 50.217 6.403 126.336-104.043-4.139v27.567l-66.438 12.201v-32.56L0 209.257 6.785 71.66 0 21.443z\" fill=\"#3E0079\" />\n        <path fill=\"#FFF\" d=\"M71 223V10h91l-4.569 50.495h-36.475v32.47h31.692v43.627h-31.692v76.68z\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol